import axios from 'axios';
import toBase64 from './toBase64';

const API_KEY = process.env.CMS_PROXY_KEY;
const API_SECRET = process.env.CMS_PROXY_SECRET;
const BASIC = 'Basic ';

const getAuthHeader = () => {
  const plainAuthKeys = `${API_KEY}:${API_SECRET}`;
  const base64AuthKeys = toBase64(plainAuthKeys);
  return `${BASIC}${base64AuthKeys}`;
};

export const getLocaleFromApi = async () => {
  try {
    const response = await axios({
      method: 'POST',
      url: 'https://www.dropbox.com/cms/get_locale',
      headers: {
        'Authorization': getAuthHeader(),
        'Content-Type': 'application/json',
    
      },
      withCredentials: true
    });
    
    return response.data.locale;
  } catch (error) {
    console.error('Error fetching locale:', error);
    return null;
  }
};

export const setLocaleToApi = async (locale) => {
  try {
    const response = await axios({
      method: 'POST',
      url: 'https://www.dropbox.com/cms/set_locale',
      headers: {
        'Authorization': getAuthHeader(),
        'Content-Type': 'application/x-www-form-urlencoded',
        
      },
      withCredentials: true,
      data: `locale=${encodeURIComponent(locale)}&`  // Form-encoded with trailing & as required by AEM
    });
    
    return response.status === 200;
  } catch (error) {
    console.error('Error setting locale:', error);
    return false;
  }
};
